import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, FirmStatistics } from '@tassat/fred-definitions';

export interface FirmStatsState {
    [key: string]: FirmStatistics;
}

const initialState: FirmStatsState = {};

const initialLoad = createAction<{ firmsStats: FirmStatsState }>('InitialLoad');
const firmStat = createAction<FirmStatistics>(CoreMsgTypes.FirmStatistics);

const firmStatsSlice = createSlice({
    name: 'firmStats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoad, (state, action) => {
                Object.assign(state, action.payload.firmsStats);
            })
            .addCase(firmStat, (state, action) => {
                state[action.payload.FirmId] = action.payload;
            });
    }
});

export default firmStatsSlice.reducer;